export default "__VITE_ASSET__Cf$CxHnZ__"